import { useSearchParams } from 'react-router'

import { SUBMENU_OUTBOUND_COMPANY_PARAM_KEY } from '../../../../constants/route'
import { useSubMenu } from '../../../../hooks'
import {
  getSubMenuIdwellToIdwellActiveValue,
  ITEM_KEYS,
} from '../../IdwellToIdwellSubMenu'

export function useIdwellToIdwellActiveOutboundCompanyUuid() {
  const [searchParams] = useSearchParams()

  const outboundCompanyUuid = searchParams.get(
    SUBMENU_OUTBOUND_COMPANY_PARAM_KEY
  )

  const subMenu = useSubMenu()

  const activeOutboundCompany = getSubMenuIdwellToIdwellActiveValue({
    outboundCompanies: subMenu.idwellToIdwellCompanies,
    value: outboundCompanyUuid,
  })

  return {
    activeOutboundCompanyName: activeOutboundCompany?.[ITEM_KEYS.titleKey],
    activeOutboundCompanyUuid: activeOutboundCompany?.[ITEM_KEYS.selectedKey],
  }
}
